import { Layer, VectorSource } from 'mapbox-gl';
import { getModule } from 'vuex-module-decorators';
import store from '@/store';
import { MapStore } from '@/store/map';

export const AddBicycleRoutes = () => {
  const mapStore = getModule(MapStore, store);
  const source: VectorSource = {
    type: 'vector',
    url: 'mapbox://maplabtech.9abwy7tf'
  };

  const layer: Layer = {
    id: 'BicycleRoute',
    type: 'line',
    source: 'BicycleRoute',
    'source-layer': 'Bike_Network-0iyziw',
    layout: {
      'line-join': 'round',
      'line-cap': 'round'
    },
    paint: {
      'line-color': '#548235',
      'line-width': 3
    }
  };
  mapStore.addSource({ source, type: 'BicycleRoute' });
  mapStore.addLayer({ layer, type: 'BicycleRoute' });
};

export const RemoveBicycleRoutes = () => {
  const mapStore = getModule(MapStore, store);
  mapStore.removeOnlyLayer({ type: 'BicycleRoute' });
  mapStore.removeSource({ type: 'BicycleRoute' });
};
